// Persistent "Client mode" flag for PROS. A barber/owner can browse the app as
// a customer (book their own haircuts); that intent must survive navigation OFF
// the /dashboard/client URL (e.g. tapping Explore Shops → /listings, Discover →
// /barbers). We persist it in a cookie so BOTH client-side chrome (floating nav)
// and server components (/barbers lens) can read the same signal.
//
// True clients (no pro role) are always in the client view via `isClient`; this
// cookie only matters for pros who opt into Client mode.

export const CLIENT_VIEW_COOKIE = "booth_view"

// Client mode (pros browsing as a customer) — RE-ENABLED everywhere
// (2026-07-03) after the stabilization pass: timezone-correct appointment
// emails, client names on pro calendars (RLS), calendar/status fixes, and the
// client-lens Discover directory. This stays the single gate every
// client-mode surface reads (entry card, floating-nav lens, /barbers +
// /listings lens, server cookie read) so it can be flipped off again in one
// place if a regression shows up: return false for
// NEXT_PUBLIC_VERCEL_ENV === "production" to hide it on the live site only.
export function isClientModeEnabled(): boolean {
  return true
}

export function readClientView(): boolean {
  if (typeof document === "undefined") return false
  if (!isClientModeEnabled()) return false
  return new RegExp(`(?:^|;\\s*)${CLIENT_VIEW_COOKIE}=client(?:;|$)`).test(document.cookie)
}

export function writeClientView(active: boolean) {
  if (typeof document === "undefined") return
  // 30-day persistence; path=/ so it's visible app-wide.
  document.cookie = `${CLIENT_VIEW_COOKIE}=${active ? "client" : "pro"}; path=/; max-age=2592000; samesite=lax`
}
